import { MfsStatusCode } from '../mfsStatusCodes';
import { getMfsTelemetryProcessor } from '../telemetryProcessor/telemetryProcessorFactory';
import { BufferContainer } from '../telemetryProcessor/utils/bufferContainer';
import { MfsLogger, parent } from './mfsLogger';
import { addShutdownEvent } from './utils/addShutdownEvent';
import { logGenericToConsole } from './utils/logToConsole';
/** Logger factory that has methods to return the relevant logger and set the global context on the telemetry processor */
export class LoggerFactory {
    constructor() {
        /** Flush all MfsLogger buffers. */
        this.flushAllBuffers = () => {
            var _a;
            const overflownBuffers = this.bufferContainer.flushableBuffers.filter((buffer) => buffer.hasOverflowed);
            if (overflownBuffers.length > 0) {
                const errorInfo = {
                    errorType: 'TelemetryBufferOverflowError',
                    message: 'The following telemetry buffers have overflown: ' +
                        overflownBuffers.map((buffer) => buffer.bufferName).join(', '),
                };
                (_a = this.telemetryProcessor) === null || _a === void 0 ? void 0 : _a.sendTelemetryErrorEvent('TelemetryBufferOverflow', "error" /* ERROR */, 'flushAllBuffers', 'telemetry', errorInfo, MfsStatusCode.DataCorruption, this.bufferContainer.getVerboseLogsToSend());
            }
            this.bufferContainer.flushableBuffers.forEach((b) => b.flush());
        };
        this.bufferContainer = new BufferContainer();
        this.telemetryProcessor = getMfsTelemetryProcessor(this.bufferContainer);
        this.loggerArray = [];
        this.telemetryLogger = this.getMfsLogger('telemetry');
    }
    /**
     * Gets instance of the singleton class
     *
     * @returns LoggerFactory instance
     */
    static getInstance() {
        return this.instance || (this.instance = new LoggerFactory());
    }
    /**
     * Gets the relevant logger respective to the component based on environment. Shouldn't send events to telemetry
     * processor on local
     *
     * @param component Component that invoked the logger
     * @returns Instance of the relevant logger
     */
    getMfsLogger(component) {
        const mfsLoggerInstance = new MfsLogger(component, this.telemetryProcessor, this.bufferContainer);
        this.loggerArray.push(mfsLoggerInstance);
        return mfsLoggerInstance;
    }
    /**
     * Sets global context on telemetry processor
     *
     * @param context MFS Logger Context to be used.
     * @param sink Telemetry Sink that will be shared between MFS and host app.
     */
    setContext(context, sink) {
        var _a;
        if (parent.extend('loader').enabled) {
            logGenericToConsole("trace" /* TRACE */, 'Setting context: %O', 'loader', context);
        }
        (_a = this.telemetryProcessor) === null || _a === void 0 ? void 0 : _a.setContext(context, this.telemetryLogger.logVerbose.bind(this.telemetryLogger), sink);
        this.flushAllBuffers();
        addShutdownEvent(() => this.flushAllBuffers());
    }
    /**
     * Sets the driveItemId that is loaded for logging.
     *
     * @param podLocationId ID of the item that is loaded
     */
    setPodLocationId(podLocationId) {
        this.telemetryProcessor.setPodLocationId(podLocationId);
    }
    /** Retrieves global context on telemetry processor */
    getContext() {
        return this.telemetryProcessor.getContext();
    }
}
//# sourceMappingURL=loggerFactory.js.map